import RewardShipmentsContent from "./RewardShipmentsContent";
export default RewardShipmentsContent;
